import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import nullBind from 'utils/functions/nullBind.util';

export const selectClientCommsSmsTextCustom = nullBind(getAnyOrNull, 'clientCommunications.clientSmsText.sms_after_reminder_custom_text');

export const selectClientCommsSmsTextPolicy = nullBind(getAnyOrNull, 'clientCommunications.clientSmsText.sms_after_reminder_cancellation_policy_text');

export const selectClientCommsSmsTextParking = nullBind(getAnyOrNull, 'clientCommunications.clientSmsText.sms_after_reminder_parking_text');

export const selectClientCommsSmsTextConsultation = nullBind(getAnyOrNull, 'clientCommunications.clientSmsText.sms_after_reminder_consultation_form_text');

export const selectClientCommsSmsSelectTemplate = nullBind(getAnyOrNull, 'clientCommunications.clientSmsText.selected_template_sms_after_reminder');

export const selectClientCommsSmsAfterReminder = ($) => $?.clientCommunications?.clientSmsText?.enable_sms_after_reminder ?? null;

export const selectClientCommsMessageSent = ($) => $?.clientCommunications?.messageSent ?? null;
export const selectClientCommsSmsCreditsAvailable = ($) => $?.clientCommunications?.sms_credits_available;
export const selectClientCommsIsFetching = ($) => $?.clientCommunications?.isFetching ?? null;
